
const ErrorHandling = (
        status, 
        errMessage, 
        setOpenErr, 
        setErrMessage, 
        dispatch, 
        logout, 
        navigate,
        errorFullMessage
    ) => {
    if (status === 401) {
        setOpenErr(true);
        setErrMessage("Token expirado, redirecionando para o login...");

        setTimeout(() => {
            dispatch(logout());
            navigate("/");
        }, 2000);
    } else {
        setOpenErr(true);

        if (errorFullMessage) {
            return setErrMessage(errorFullMessage);
        }
        
        setErrMessage(errMessage);
    }
}

export { ErrorHandling };